import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { Col, Row } from "reactstrap";
import moment from "moment";

export default function UnderstandingAsset(props) {
  const { productDetails } = props;
  const [isMobile, setIsMobile] = useState(false);
  const [assetDetails, setAssetDetails] = useState(null);

  const parameters= [
    {
      key: "AUM",
      value: props?.mldAssetDetails?.aum
    },
    {
      key: "Net Worth",
      value: props?.mldAssetDetails?.netWorth
    },
    {
      key: "Profit Before Tax",
      value: props?.mldAssetDetails?.profitAfterTax
    },
    {
      key: "GNPA / NNPA",
      value: props?.mldAssetDetails?.gnpa
    }
  ]

  useEffect(() => {
    setIsMobile(window.matchMedia("(max-width: 768px)").matches);
  }, []);

  useEffect(() => {
    setAssetDetails({
      title: "About " + productDetails.productName,
      logoName: productDetails.fundId + " Finserv Limited",
      logo: productDetails.descLogoUrl,

      description:
      productDetails.description,
      lastArr: [
        get(props, "assetDetails.aum", "") ? 
        {
          key: "Total Annual Revenue",
          value: get(props, "assetDetails.aum", "")
            ? get(props, "assetDetails.aum", "")
            : "NA",
        } : null ,
        get(props, "assetDetails.netWorth", "") ? 
        {
          key: "Year of Inception",
          value: get(props, "assetDetails.netWorth", ""),
        } : null,
        get(props, "assetDetails.marketCap", "") ? 
        {
          key: "Industry",
          value: get(props, "assetDetails.marketCap", ""),
        } : null,
      ],
    });
  }, [props]);

  return (
    <div style={{backgroundColor:"white"}} className={"second-fold-main "} onClick={props.onClick}>
      <Row className="navi-second-fold">
        {/* {isMobile && <div className="navi-separator" />} */}
        <p className="main-title mb-0">{assetDetails?.title}</p>
        <div className="second-table-container">
          <Col lg={4}>
            <img
              style={!isMobile ? {height: "300px"} : {height: "200px"}}
              src={assetDetails?.logo}
              alt="logo"
            />
          </Col>
          <Col lg={8}>
            {!isMobile && (
              <div className="second-table">
                {parameters.map((item, index) => (
                  (item) ?
                  <Col lg={3} key={index}>
                    <p className="font-size-18 text-muted">{item?.key}</p>
                    <p className="navi-font-22 font-weight-semi-bold">
                      {item?.value}
                    </p>
                  </Col> : null
                ))}
              </div>
            )}
            <p className="description">{assetDetails?.description}</p>
            {isMobile && (
              <div className="second-table-mob" onClick={props.onClick}>
                {parameters.map((item, index) => (
                  <Col md={6} sm={6} xs={6} key={index}>
                    <p className="navi-font-14 text-muted mb-0">{item?.key}</p>
                    <p className="navi-font-16 font-weight-medium">
                      {item?.value}
                    </p>
                  </Col>
                ))}
              </div>
            )}
            {!isMobile ?
              <div className="desc-section d-flex mt-3">
                <Col>
                  <div style={{ width: "fit-content" }}>
                    <p
                      className="descTitle"
                      dangerouslySetInnerHTML={{ __html: props?.aboutIcm?.descTitle }} 
                    />
                    <p className="description">
                      Incred offers lending to all categories of borrowers including retail lending and lending 
                      to businesses by way of Consumer Loans, Education Loans and MSME Loans.
                    </p>
                  </div>
                </Col>
                <Col>
                  <div className="description2">
                    <li>Face Value (Rs.) : {props?.mldAssetDetails?.faceValue ? props?.mldAssetDetails?.faceValue : "--"} </li>
                    <li>Original Mode of Issue: {props?.mldAssetDetails?.issueType ? props?.mldAssetDetails?.issueType : "--"}</li>
                    <li>Issue Open Date: {props?.mldAssetDetails?.issueDate ? 
                      moment(new Date(props?.mldAssetDetails?.issueDate).getTime()).format("Do MMM'YY") : "--"}</li>
                    <li>Rating: {props?.mldAssetDetails?.rating ? props?.mldAssetDetails?.rating : "--"}</li>

                  </div>
                </Col>
              </div> :
              <div>
                <Row>
                  <div style={{ width: "fit-content" }}>
                    <p
                      className="descTitle"
                      dangerouslySetInnerHTML={{ __html: props?.aboutIcm?.descTitle }} 
                    />
                    <p className="description">
                      Incred offers lending to all categories of borrowers including retail lending and lending 
                      to businesses by way of Consumer Loans, Education Loans and MSME Loans.
                    </p>
                  </div>

                  <div className="description2 ml-4">
                    <li>Face Value (Rs.) : {props?.mldAssetDetails?.faceValue ? props?.mldAssetDetails?.faceValue : "--"} </li>
                    <li>Original Mode of Issue: {props?.mldAssetDetails?.issueType ? props?.mldAssetDetails?.issueType : "--"}</li>
                    <li>Issue Open Date: {props?.mldAssetDetails?.issueDate ? 
                      moment(new Date(props?.mldAssetDetails?.issueDate).getTime()).format("Do MMM'YY") : "--"}</li>
                    <li>Rating: {props?.mldAssetDetails?.rating ? props?.mldAssetDetails?.rating : "--"}</li>
                  </div>
                </Row>
              </div>
            }
            {/* <div className="mt-4">
                    <Button
                      className="invest-btn"
                    >
                      Apply Ipo
                    </Button>
            </div> */}
          </Col>
        </div>
      </Row>
    </div>
  );
}
